<template>
  <div class="view">
    <!-- Top Bar-->
    <top-bar v-if="isPortalReady" />

    <!-- Site Content -->
    <div class="container">
      <!--<div class="block_static">
        <div class="row" style="display: flex; align-items: center">
          <div class="col-sm-6">
            <div class="header_block_static">
              <span>Selecciona tu curso favorito</span>
              <div class="descripcion_block_static">
                <div>
                  Topclass es la plataforma latinoamericana que ofrece una nueva
                  y entretenida experiencia de aprendizaje online, a través
                  cursos dictados por reconocidos especialistas y celebridades,
                  de quienes aprenderás nuevos conocimientos a través de su
                  experiencia personal y profesional.
                </div>
                <div>
                  Podrás verlos en el horario que tú escojas, desde el lugar que
                  quieras y avanzar a tu ritmo.&nbsp;
                </div>
              </div>
              <br />
            </div>
          </div>
          <div class="col-sm-6 ocultar-movil">
            <div class="container">
              <div
                id="container-video-10"
                class="container-video"
                style="background-image: none"
              >
                <img
                  src="https://res.cloudinary.com/dmx3pf3os/image/upload/fl_lossy/v1549657452/galerias/dm64LnaHVW_mesa-de-trabajo-1png.png"
                />
                <div class="banner-content-video-movil"></div>
                <div class="banner-content-home"></div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <div class="home-curso-list">
        <h3 class="home-curso-list-title">Cursos</h3>
        <curso-list
          :cursos="cursos"
          columnas="4"
          @cursoClick="seleccionarCurso"
        />
      </div>
    </div>

    <!-- Modales -->
    <b-modal
      v-model="isSelectCursoModalVisible"
      :busy="true"
      centered
      hide-footer
      title="Confirmar Suscripcion"
    >
      <div class="text-center">
        <label>{{ this.productoSelect.producto }}</label>
        <img
          class="curso-card-image"
          :src="
            typeof productoSelect.foto_principal !== 'undefined' &&
            productoSelect.foto_principal.includes('/fl_lossy/')
              ? productoSelect.foto_principal
              : typeof productoSelect.foto_principal !== 'undefined'
              ? productoSelect.foto_principal
                  .replace('upload', 'upload/fl_lossy')
                  .replace('http:', 'https:')
              : ''
          "
        />
        <br /><br />
      </div>

      <!-- Inicio del Formulario Already Sold -->
      <form
        action=""
        ref="already-sold-form"
        :class="{
          validated: validated,
        }"
        @submit.prevent="manejadorDeSuscripcion"
      >
        <!-- Input Email -->
        <div class="form-group" v-show="!mostrarInputPasword">
          <label for="alredySoldFormEmail">Email</label>
          <input
            type="email"
            class="form-control"
            id="alredySoldFormEmail"
            aria-describedby="emailHelp"
            placeholder="Email"
            required
            v-model="email"
            :disabled="mostrarInputPasword"
          />
          <div class="invalid-feedback">Email inválido</div>
        </div>

        <!-- Input Fecha de nacimiento -->
        <div class="form-group" v-show="!mostrarInputPasword">
          <label for="alredySoldFormFechaNac">Fecha de nacimiento</label>

          <input
            type="date"
            class="form-control"
            id="alredySoldFormFechaNac"
            required
            v-model="fechaNac"
            :disabled="mostrarInputPasword"
          />
          <div class="invalid-feedback">Este campo no puede ir vacío.</div>
        </div>

        <!-- Input Password -->
        <div class="form-group" v-show="mostrarInputPasword">
          <label for="alreadySoldFormPassword"
            >Crea una contraseña para acceder</label
          >

          <input
            type="password"
            class="form-control"
            id="alreadySoldFormPassword"
            ref="alreadySoldFormPassword"
            v-model="password"
            placeholder="Introduce una contraseña"
            :disabled="!mostrarInputPasword"
            minlength="8"
            required
          />
          <div id="emailHelp" class="form-text">
            La Contraseña debe tener un minimo de 8 caracteres
          </div>
          <div class="invalid-feedback">
            Este campo es necesario para la suscripción
          </div>
        </div>

        <!-- TODO Pedir Tambien Nombre y Apellido, numero de telefono y password-->

        <!-- Mensaje de trabajo General-->
        <div class="text-center alert-text-box" v-if="realizandoProcesoGeneral">
          <p>
            {{ procesoGeneralMessage }} <br />
            <spinner class-name="color-red" />
          </p>
        </div>

        <!-- Mensaje Respuesta General -->
        <div
          class="text-center alert-text-box"
          v-if="mensajeRespuestaGeneral != ''"
        >
          <p class="color-gray" v-html="mensajeRespuestaGeneral"></p>
        </div>

        <!-- Mensaje de respuesta de descuento -->
        <div
          class="text-center"
          style="margin-top: 10px"
          :class="{
            'color-red': !colorMensajeDescuento,
            'color-green': colorMensajeDescuento,
          }"
          v-if="descuentoMessage != ''"
        >
          {{ descuentoMessage }}
        </div>

        <!-- Boton Submit Form -->
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-primary w-100 btn-noradius"
            style="height: 45px; margin-top: 10px"
            ref="alredySoldFormSubmitButtom"
            :disabled="realizandoProcesoGeneral"
          >
            Consultar
          </button>
        </div>
      </form>
      <!-- Fin del Formulario Already Sold -->
      <div
        class="text-center alert-text-box"
        v-if="this.isSelectCursoCheck || this.isSelectCursoMessage != ''"
      >
        <p v-if="this.isSelectCursoCheck">
          Confirmando <spinner class-name="color-red" />
        </p>
        <p v-if="this.isSelectCursoMessage != ''">
          {{ this.isSelectCursoMessage }}<br />
          Redireccionando <spinner class-name="color-red" />
        </p>
      </div>
    </b-modal>

    <!-- Site Footer-->
    <!-- <site-footer v-if="isPortalReady" :verFooter="true" /> -->
  </div>
</template>

<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import TopBar from "../components/TopBar";
import { mapState, mapGetters } from "vuex";
import {
  getProducto,
  getCategoriaDeProducto,
  getProductoDeCategoria,
  eventKlaviyo,
} from "../utilities/data";
import { randomString, isValidEmail, isValidTelefono } from "../utilities/util";

export default {
  name: "CheckoutAlreadySoldLanding",
  components: {
    bModal,
    CursoList,
    SiteFooter,
    Spinner,
    TopBar,
  },
  computed: {
    categoria() {
      return getCategoriaDeProducto(this.portal, this.producto.id);
    },
    cursos() {
      return this.portal.categorias
        .map((categoria) => {
          return {
            categoria,
            producto: getProductoDeCategoria(this.portal, categoria.id),
          };
        })
        .filter((producto) => producto.categoria !== false);
    },
    isEmailValid() {
      return isValidEmail(this.email);
    },
    ...mapState(["portal", "user", "isPortalReady"]),
    producto() {
      return this.portal.productos_portal
        ? getProducto(this.portal, this.$route.params.id)
        : {};
    },
  },
  data() {
    return {
      categoriaSelect: {},
      colorMensajeDescuento: false,
      consultandoDescuento: true,
      consultandoDescuentoMessage: "",
      descuento: {},
      descuentoMessage: "",
      email: "",
      fechaNac: "",
      idDescuento: null,
      isSelectCursoCheck: false,
      isSelectCursoMessage: "",
      isSelectCursoModalVisible: false,
      mensajeDescuentoAplicado: "",
      mensajeRespuestaGeneral: "",
      montoTotal: 0,
      mostrarInputPasword: false,
      password: "",
      portalPasarelas: [],
      procesoGeneralMessage: "",
      productoSelect: {},
      realizandoProcesoGeneral: false,
      realizandoProcesoGeneralPasos: 0,
      selectedPortalPasarela: {},
      validated: false,

      //Mensajes
      mensajes: {
        "METODO PAGO INVALIDO": "Por favor escoge otro medio de pago.",
        "COMPRA NO ENCONTRADA": "Compra inválida.",
        "EL PRODUCTO YA SE ENCUENTRA DISPONIBLE": "Ya tienes este producto.",
        "PARAMETROS VACIOS": "Por favor coloca todos los datos requeridos.",
        "PARAMETROS REQUERIDOS": "Por favor coloca todos los datos requeridos.",
        "ERROR TOKEN INVALIDO":
          "Error procesando la compra, por favor intenta de nuevo.",
        ERROR: "Error procesando la compra, por favor intenta de nuevo.",
        "ALTA EXISTE":
          "Error el numero de telefono se encuentra dado alta con este servicio",
        "OPERADOR INVALIDO":
          "El numero de telefono no corresponde con el operador seleccionado",
        "TELEFONO VACIO, INVALIDO O FALTAN PARAMETROS":
          "Error procesando la compra, por favor intenta de nuevo.",
        "El movil no tiene saldo.": "El movil no tiene saldo.",
        "Fallo en configuracion de validacion.":
          "Fallo en configuracion de validacion.",
        "El movil ya esta agendado.": "El movil ya esta agendado.",
        "El plan no se encuentra registrado":
          "El plan no se encuentra registrado",
        "IP no autorizada.": "IP no autorizada.",
        "Contenido no valido.": "Contenido no valido.",
        "Entrada no valida.": "Entrada no valida.",
        "Suscripcion Fallida.": "Suscripcion Fallida.",
        "Cobro Fallido.": "Cobro Fallido.",
        "Error Interno.": "Cobro Fallido.",
        "El movil debe pertenecer a EPCS.": "El movil debe pertenecer a EPCS.",
        "El movil no es compatible.": "El movil no es compatible.",
        "El movil esta en roaming.": "El movil esta en roaming.",
        "El movil tiene bloqueado el servicio.":
          "El movil tiene bloqueado el servicio.",
        "Solicitud no valida.": "Solicitud no valida.",
        "El movil no tiene perfil compatible":
          "El movil no tiene perfil compatible",
        "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones":
          "El proveedor ha alcanzado el límite Diario y Mensual de suscripciones",
        "El proveedor ha alcanzado el límite Diario de suscripciones":
          "El proveedor ha alcanzado el límite Diario de suscripciones",
        "El proveedor ha alcanzado el límite Mensual de suscripciones":
          "El proveedor ha alcanzado el límite Mensual de suscripciones",
        "El movil no posee tokens": "El movil no posee tokens",
        "La url al servicio segmentate no esta disponible":
          "La url al servicio segmentate no esta disponible",
        "El pin ingresado es incorrecto": "El pin ingresado es incorrecto",
        "Error al suscribir al movil": "Error al suscribir al movil",
        "CREDITOS INSUFICIENTES": "Error los créditos son insuficientes",
      },
    };
  },
  watch: {
    //ACTIVAR IMPRESION DE PRODUCTOS
    cursos(val, old) {
      let impression = [];
      val.forEach((curso) => {
        impression.push({
          name: curso.producto.producto, // Name or ID is required.
          id: curso.producto.id,
          price: curso.producto.precio,
          category: curso.categoria.categoria,
          list: "Home",
          position: curso.categoria.posicion,
        });
      });
      dataLayer.push({
        event: "impressions",
        ecommerce: {
          currencyCode: "CLP",
          impressions: impression,
        },
      });
    },
  },
  methods: {
    aplicarDescuento() {
      //Mostrar Mensaje de proceso general
      this.realizandoProcesoGeneral = true;
      this.procesoGeneralMessage = "Consultando Email y descuento";

      //validar inputs del form
      let postData = {
        codigo_descuento: this.email,
        id_producto: this.productoSelect.id,
      };

      this.descuentoMessage = "";

      this.$api
        .descuentos(postData)
        .then((response) => {
          //Ocultar Mensaje de proceso general
          this.realizandoProcesoGeneral = false;
          this.procesoGeneralMessage = "";

          dataLayer.push({
            event: "cupon-descuento",
          });

          if (
            typeof response.data.response !== "undefined" &&
            response.data.response !== "200"
          ) {
            this.descuentoMessage =
              "Este Email no esta habilitado para la compra de este curso";
            this.colorMensajeDescuento = false;
            return false;
          }

          this.mensajeDescuentoAplicado = "Se aplico un descuento de <b>";

          if (response.data.data.tipo_promocion == "porcentaje") {
            this.montoTotal =
              this.productoSelect.precio * (response.data.data.monto / 100);
            this.montoTotal = this.productoSelect.precio - this.montoTotal;
            this.mensajeDescuentoAplicado +=
              response.data.data.monto +
              " % <br> Monto  total  a pagar :</b> <h3>" +
              this.montoTotal.toFixed(0) +
              "</h3>";
          }
          if (response.data.data.tipo_promocion == "monto") {
            this.montoTotal =
              this.productoSelect.precio - response.data.data.monto;
            this.mensajeDescuentoAplicado +=
              response.data.data.monto +
              " CLP <br> Monto  total  a pagar : </b> <h3>" +
              this.montoTotal.toFixed(0) +
              "</h3>";
          }

          this.idDescuento = response.data.data.id;
          this.descuentoMessage = response.data.message;
          this.descuento = { ...response.data.data };
          this.colorMensajeDescuento = true;
          this.mostrarInputPasword = true;
          this.$refs.alredySoldFormSubmitButtom.innerHTML = "Confirmar";
        })
        .catch((error) => {
          console.log(error);
          //Ocultar Mensaje de proceso general
          this.realizandoProcesoGeneral = false;
          this.procesoGeneralMessage = "";
        });
    },
    cargar_pasarela(id_product) {
      //LLenar Arreglo de pasarelas asociadas al producto/curso
      if (
        this.portal.productos_portal.filter(
          (producto) => producto.id == id_product
        ).length > 0
      ) {
        // Cargar pasarelas del producto/portal
        this.portalPasarelas = this.portal.productos_portal
          .filter((producto) => producto.id == id_product)[0]
          .productos_pasarelas.map((pp) => {
            return {
              id_portal_pasarela: pp.id_portal_pasarela,
              pasarela: pp.productos_portal_pasarela[0].pasarelas[0],
            };
          });

        //Seleccionar pasarela compra interna
        if (this.portalPasarelas.length > 0) {
          let pasarelaCompraInterna = this.portalPasarelas.find(
            ({ pasarela }) => {
              //Encontrar pasarela movil
              if (pasarela.pasarela === "Descuento") {
                return pasarela;
              }
            }
          );

          this.selectedPortalPasarela = pasarelaCompraInterna;
        }
      } else {
        // El id del curso no existe.
        this.$router.replace({ name: "error404" });
      }
    },
    manejadorDeSuscripcion() {

      console.log("manejador de suscripccion");

      //Si el descuento no ha sido aplicado y el password esta vacio
      if (
        Object.keys(this.descuento).length === 0 &&
        this.password === ""
      ) {
        this.aplicarDescuento();
      }
      //Si el descuento ya fue aplicado pero falta el password
      else if (
        Object.keys(this.descuento).length !== 0 &&
        this.password === ""
      ) {
        console.log("error Falta la contraseña");
        return false;
      }
      //Si el descuento ya fue aplicado y ya hay un password
      else if (
        Object.keys(this.descuento).length !== 0 &&
        this.password !== ""
      ) {
        this.suscribirAlCurso();
      }
    },
    seleccionarCurso(categoria, producto) {
      //seleccionar pasarelas del curso
      this.cargar_pasarela(producto.id);

      this.productoSelect = producto;
      this.categoriaSelect = categoria;
      this.isSelectCursoModalVisible = true;

      //Definir paso de proceso general
      this.realizandoProcesoGeneralPasos = 0;

      // Precio a pagar en la suscripcion del producto
      this.montoTotal = producto.precio;
    },
    start() {
      console.log("inicio Start");
      this.seleccionarCurso(this.categoria, this.producto);
    },
    suscribirAlCurso() {
      //Mostrar Mensaje de proceso general
      this.realizandoProcesoGeneral = true;

      //limpiar respuesta general del proceso
      this.mensajeRespuestaGeneral = "";

      //Validar Email
      this.procesoGeneralMessage = "Validando Email";
      if (!this.isEmailValid) {
        //limpiar descuento y empezar trabajo de nuevo
        this.descuento = {};
        //Ocultar Mensaje de proceso general
        this.realizandoProcesoGeneral = false;
        this.procesoGeneralMessage = "";
        this.mensajeRespuestaGeneral = "";
        this.descuentoMessage = "";

        return false;
      }

      //Validar descuento
      this.procesoGeneralMessage = "Validando Descuento";

      if (this.descuento.status === 0) {
        //limpiar descuento y empezar trabajo de nuevo
        this.descuento = {};
        //Ocultar Mensaje de proceso general
        this.realizandoProcesoGeneral = false;
        this.procesoGeneralMessage = "";
        this.mensajeRespuestaGeneral = "";
        this.descuentoMessage = "";

        return false;
      }

      //Validar Password
      this.procesoGeneralMessage = "Validando Contraseña";

      if (this.password === "") {
        //Ocultar Mensaje de proceso general
        this.realizandoProcesoGeneral = false;
        this.procesoGeneralMessage = "";
        this.mensajeRespuestaGeneral = "";
        return false;
      }

      //Registrar Usuario
      this.procesoGeneralMessage = "Registrando Usuario";

      //TODO Traer informacion del usuario desde tabla de descuentos

      let newUserData = {
        usuario: this.email,
        activarCuentaCheckout: 1,
        name: "",
        apellido: "",
        email: this.email,
        telefono: "",
        password: this.password,
        direccion: "",
        sexo: "",
        fecha_nac: this.fechaNac,
        termino_condicion: 1,
        utm_source: localStorage.getItem("utm_source"),
        utm_medium: localStorage.getItem("utm_medium"),
        utm_campaign: localStorage.getItem("utm_campaign"),
      };

      this.$store
        .dispatch("registro", newUserData)
        .then((response) => {
          this.procesoGeneralMessage = "Iniciando session con nuevo usuario";
          //Hacer Login
          this.$store
            .dispatch("login", {
              email: this.email,
              password: this.password,
              validarEntrada: "CHECKOUTPRESOLD",
            })
            .then((response) => {
              //Hacer Compra con Descuento
              this.procesoGeneralMessage = "Asignando Curso a Usuario Nuevo";

              //Eventos de login
              //this.$emit("loginSuccessful", response);
              dataLayer.push({
                event: "sesion-iniciada",
              });

              //Hacer compra con pasarela con descuento
              let pagoUrlParams = {
                id_producto: this.productoSelect.id,
                id_portal_pasarela: this.selectedPortalPasarela
                  .id_portal_pasarela,
                id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
                id_descuento: this.descuento.id,
                id_user_share: "",
                total: this.productoSelect.precio,
                network:
                  Object.getOwnPropertyNames(this.$route.query).length > 0
                    ? this.$route.query
                    : "",
                utm_source: localStorage.getItem("utm_source"),
                utm_medium: localStorage.getItem("utm_medium"),
                utm_campaign: localStorage.getItem("utm_campaign"),
              };

              console.log("Pagop url params", JSON.stringify(pagoUrlParams));

              this.$api.getPagoUrl(pagoUrlParams).then((response) => {
                if ("message" in response.data) {

                  //mostrar respuesta general de error al usuario
                  this.mensajeRespuestaGeneral = "Hubo un error al realizar la suscripción";

                  //limpiar descuento y empezar trabajo de nuevo
                  this.descuento = {};
                  //Ocultar Mensaje de proceso general
                  this.realizandoProcesoGeneral = false;
                  this.procesoGeneralMessage = "";

                  setInterval(() => {
                    this.mensajeRespuestaGeneral = "";
                  }, 5000);

                  //mostrar formulario desde el principio
                  this.mostrarInputPasword = false;

                  //Limpiar mensaje de descuento
                  this.descuentoMessage = "";

                  //Limpiar Password
                  this.password = "";

                  return false;
                  
                } else {
                  window.location = response.data.response;
                }
              });
            })
            .catch((error) => {

              console.log("error en Login", error);
            
              //mostrar respuesta general de error al usuario
              this.mensajeRespuestaGeneral = "Hubo un error al iniciar la sessión";

              //limpiar descuento y empezar trabajo de nuevo
              this.descuento = {};
              //Ocultar Mensaje de proceso general
              this.realizandoProcesoGeneral = false;
              this.procesoGeneralMessage = "";

              setInterval(() => {
                this.mensajeRespuestaGeneral = "";
              }, 5000);

              //mostrar formulario desde el principio
              this.mostrarInputPasword = false;

              //Limpiar mensaje de descuento
              this.descuentoMessage = "";

              //Limpiar Password
              this.password = "";

              return false;

            });
        })
        .catch((error) => {
          console.log("Error Resgitro", error);

          //mostrar respuesta general de error al usuario
          this.mensajeRespuestaGeneral = error.data.message;

          //limpiar descuento y empezar trabajo de nuevo
          this.descuento = {};
          //Ocultar Mensaje de proceso general
          this.realizandoProcesoGeneral = false;
          this.procesoGeneralMessage = "";

          setInterval(() => {
            this.mensajeRespuestaGeneral = "";
          }, 5000);

          //mostrar formulario desde el principio
          this.mostrarInputPasword = false;

          //Limpiar mensaje de descuento
          this.descuentoMessage = "";

          //Limpiar Password
          this.password = "";

          return false;
        });
    },
  },
  created() {
  },
  mounted() {
    //Inicializar pagina y reaccionar a url de entel o wom
    if (this.portal.productos_portal) {
      this.start();
    }
  },
};
</script>

<style>
</style>